/** 左侧菜单排序 */

export default {

  /** 这些为系统菜单 */
  System: 100000,
  Permission: 100010,
  LocalExtension: 100050
}
